import React from 'react';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import { dateFn } from '../../../utils/dateTimeFormatter';
import { amountCheckFn, statusBgSwitch, statusTextSwitch } from '../../../utils/commonUtil';
import { titleCaseFormatter } from '../../../utils/stringFormatters';
import { ChevronRightIcon, StarIcon } from '@heroicons/react/20/solid';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { StarIcon as StarIcon2 } from '@heroicons/react/24/outline';
import { roundedRatingValue } from '../../../components/Utils';
function SingleOrder({ order, tipModalOpen, ratingModalOpen }) {
  const navigate = useNavigate();
  const serviceAddressName = order?.customer_address?.name;
  const serviceStreetAddress = order?.customer_address?.full_address?.split(',')[0]?.trim();
  const hasServiceAddress = serviceAddressName || serviceStreetAddress;

  return (
    <div className={`mb-4 rounded-lg bg-white shadow sm:mb-6`}>
      <div className='items-center justify-between space-y-2 space-x-2 sm:space-y-4 md:flex md:space-y-0'>
        <div
          className='flex w-full cursor-pointer flex-col space-x-2 sm:flex-row sm:space-x-4'
          onClick={() => navigate(`/order/${order?.id}`)}
        >
          <div className=' w-full '>
            <div
              className={` hidden items-start gap-4 rounded-t-lg py-4 px-4 sm:flex sm:py-4 sm:px-6 ${statusBgSwitch(
                order?.status
              )} ${statusTextSwitch(order?.status)}`}
            >
              <div className='min-w-[120px] flex-none'>
                <span className='font-semibold'>{titleCaseFormatter(order?.status)} </span>
              </div>
              <div className='flex flex-1 items-center justify-center'>
                {order?.tenant_rating && (
                  <div className='flex items-center gap-6'>
                    <div className='flex items-center justify-center'>
                      <span className='labelDefault'>Co</span>
                      <StarIcon className='mx-1 h-4 w-4 text-black' />
                      <span className='bodyText'>{roundedRatingValue(order?.tenant_rating?.rating)}</span>
                    </div>
                    <div className='flex items-center justify-center'>
                      <span className='labelDefault'>Pro</span>
                      <StarIcon className='mx-1 h-4 w-4 text-black' />
                      <span className='bodyText'>{roundedRatingValue(order?.worker_rating?.rating)}</span>
                    </div>
                  </div>
                )}
                {order?.status == 'DELIVERED' && !order?.tenant_rating && (
                  <div className='flex items-center justify-center'>
                    <StarIcon2 className='mr-1 h-5 w-5 text-black' />
                    <Button
                      variant='link'
                      text='Rate Order'
                      classes={'px-0 !py-0 ml-1'}
                      onClick={(e) => {
                        ratingModalOpen(e, true, order);
                      }}
                    />
                  </div>
                )}
              </div>
              <span className='bodyText flex-none text-right'>Order #{order?.id}</span>
            </div>
            <div
              className={`rounded-t-lg py-4 px-4 sm:hidden sm:py-4 sm:px-6 ${statusBgSwitch(
                order?.status
              )} ${statusTextSwitch(order?.status)}`}
            >
              <div className='flex items-start justify-between gap-2'>
                <div className='min-w-0 flex-1'>
                  <span className='font-semibold'>{titleCaseFormatter(order?.status)} </span>
                </div>
                <div className='flex-none text-right'>
                  <div className='bodyText text-client-link text-right'>Order #{order?.id}</div>
                </div>
              </div>
              <div className='flex items-start justify-between gap-2'>
                <div className='min-w-0 flex-1'>
                  {hasServiceAddress && (
                    <div className='flex min-w-0 items-center gap-1'>
                      <MapPinIcon className='text-client-800 h-4 w-4 flex-none' aria-hidden='true' />
                      <div className='bodyText min-w-0 truncate'>
                        {serviceAddressName && <span className='font-semibold'>{serviceAddressName}</span>}
                        {/* {serviceAddressName && serviceStreetAddress && <span className='px-1'>-</span>} */}
                        {/* {serviceStreetAddress && <span>{serviceStreetAddress}</span>} */}
                      </div>
                    </div>
                  )}
                </div>
                <div className='flex-none text-right'>
                  {order?.tenant_rating && (
                    <div className='flex items-center justify-end gap-3'>
                      <div className='flex items-center justify-center'>
                          <span className='labelDefault'>Co</span>
                        <StarIcon className='mx-1 h-4 w-4 text-black' />
                        <span className='bodyText'>{roundedRatingValue(order?.tenant_rating?.rating)}</span>
                      </div>
                      <div className='flex items-center justify-center'>
                          <span className='labelDefault'>Pro</span>
                        <StarIcon className='mx-1 h-4 w-4 text-black' />
                        <span className='bodyText'>{roundedRatingValue(order?.worker_rating?.rating)}</span>
                      </div>
                    </div>
                  )}

                  {order?.status == 'DELIVERED' && !order?.tenant_rating && (
                    <div className='flex items-center justify-end'>
                      <StarIcon2 className='mr-1 h-5 w-5 text-black' />
                      <Button
                        variant='link'
                        text='Rate Order'
                        classes={'px-0 !py-0 ml-1'}
                        onClick={(e) => {
                          ratingModalOpen(e, true, order);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className=' flex justify-between px-4 py-3 sm:hidden sm:px-6'>
              <div className='flex-col'>
                <div className='bodyText'>
                  {dateFn(
                    'toTZOnlyDate',
                    order?.pickup_date,
                    order?.pickup_start_time,
                    order?.pickup_end_time,
                    order?.customer_address?.time_zone
                  )}
                </div>
                <div className='bodyText'>
                  {dateFn(
                    'toTZOnlyTimes',
                    order?.pickup_date,
                    order?.pickup_start_time,
                    order?.pickup_end_time,
                    order?.customer_address?.time_zone
                  )}
                </div>
                <div className='labelDefault'>Pick Up</div>
              </div>
              <div className='flex-col text-right'>
                <div className='bodyText'>
                  {dateFn(
                    'toTZOnlyDate',
                    order?.dropoff_date,
                    order?.dropoff_start_time,
                    order?.dropoff_end_time,
                    order?.customer_address?.time_zone
                  )}
                </div>
                <div className='bodyText'>
                  {dateFn(
                    'toTZOnlyTimes',
                    order?.dropoff_date,
                    order?.dropoff_start_time,
                    order?.dropoff_end_time,
                    order?.customer_address?.time_zone
                  )}
                </div>
                <div className='labelDefault'>Delivery</div>
              </div>
            </div>
            <div className='flex justify-between border-t border-gray-300 px-4 py-3 sm:hidden sm:px-6'>
              <div className='flex-col'>
                <div className='bodyText'>{amountCheckFn(order?.final_total)}</div>
                <div className='labelDefault'>
                  {order?.status == 'DELIVERED' ? 'Total Cost' : 'Estimated Total Cost'}
                </div>
              </div>
              <div className='flex-col text-right'>
                <div className='bodyText'>
                  {(order?.status == 'WAITING' || order?.status == 'PICKUP_COMPLETE' || order?.status == 'DELIVERED') &&
                    (order?.final_tip ? (
                      <div className='flex-col'>
                        <div> {amountCheckFn(order?.final_tip)}</div>
                        <div className='labelDefault'>Tip</div>
                      </div>
                    ) : dateFn('daysBetween', order?.dropoff_date) > 30 ? (
                      '$0'
                    ) : (
                      <div className='flex-col'>
                        <div> {amountCheckFn(order?.final_tip)}</div>
                        <Button
                          variant='link'
                          text='Add Tip'
                          classes={'px-0 !py-0 ml-2'}
                          onClick={(e) => {
                            tipModalOpen(e, true, order);
                          }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className=' hidden justify-between px-4 py-3 sm:flex sm:px-6'>
              <div className='min-w-0 flex-1 pr-6'>
                <div className='mb-2 flex space-x-1'>
                  <span className='labelDefault pr-4'>Pick Up</span>
                  <span className='bodyText'>
                    {dateFn(
                      'toTZWithSeparator',
                      order?.pickup_date,
                      order?.pickup_start_time,
                      order?.pickup_end_time,
                      order?.customer_address?.time_zone
                    )}
                  </span>
                </div>
                <div className='flex space-x-1'>
                  <span className='labelDefault pr-4'>Delivery</span>
                  <span className='bodyText'>
                    {dateFn(
                      'toTZWithSeparator',
                      order?.dropoff_date,
                      order?.dropoff_start_time,
                      order?.dropoff_end_time,
                      order?.customer_address?.time_zone
                    )}
                  </span>
                </div>
                {hasServiceAddress && (
                  <div className='mt-2 flex items-center gap-2'>
                    <MapPinIcon className='text-client-800 h-4 w-4 flex-none' aria-hidden='true' />
                    <div className='bodyText min-w-0 truncate'>
                      {serviceAddressName && <span className='font-semibold'>{serviceAddressName}</span>}
                    </div>
                  </div>
                )}
              </div>
              <div className='flex flex-none flex-col items-end text-right'>
                <div className='mb-2 flex'>
                  <span className='labelDefault pr-2 text-right'>
                    {order?.status == 'DELIVERED' ? 'Total Cost' : 'Estimated Total Cost'}
                  </span>
                  <span className='bodyText w-auto'>{amountCheckFn(order?.final_total)}</span>
                </div>

                {(order?.status == 'WAITING' || order?.status == 'PICKUP_COMPLETE' || order?.status == 'DELIVERED') &&
                  (order?.final_tip ? (
                    <div className='mb-2 flex'>
                      <span className='labelDefault pr-2 text-right'>Tip:</span>
                      <span className='bodyText w-auto'>{amountCheckFn(order?.final_tip)}</span>
                    </div>
                  ) : dateFn('daysBetween', order?.dropoff_date) > 30 ? (
                    <div className='mb-2 flex'>
                      <span className='labelDefault pr-2 text-right'>Tip:</span>
                      <span className='bodyText'>$0</span>
                    </div>
                  ) : (
                    <div className='mb-2 flex'>
                      <span className='labelDefault pr-2 text-right'>Tip:</span>
                      <span className='bodyText w-auto'>{amountCheckFn(order?.final_tip)}</span>
                      <Button
                        variant='link'
                        text='Add Tip'
                        classes={'px-0 !py-0 ml-2'}
                        onClick={(e) => {
                          tipModalOpen(e, true, order);
                        }}
                      />
                    </div>
                  ))}
                <div>
                  <Button
                    variant='link'
                    text='View Details'
                    onClick={() => navigate(`/order/${order?.id}`)}
                    icon={<ChevronRightIcon className='h-6 w-6' />}
                    iconPosition='right'
                    classes={'px-0 !py-0'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleOrder;
